<lib-ui-shimmer-fragment height="1000" />
